import { Link } from 'react-router-dom';
import { DestinationMarquee } from './landing/DestinationMarquee';

/**
 * Site footer — Warm Editorial. A destinations ticker sits at the top, then the
 * ink band with the wordmark, a short brand line and a light directory of links.
 */
export function SiteFooter() {
  return (
    <footer className="mt-24 bg-ink text-cream/80">
      {/* Destinations ticker — top of the footer */}
      <DestinationMarquee />

      <div className="border-t border-white/10 px-6 py-14 sm:px-10 lg:px-16 2xl:px-24">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <span className="font-serif text-2xl font-semibold text-cream">
              BestAcco<span className="text-clay">.</span>
            </span>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-cream/70">
              A curated directory of distinctive, hand-picked hotels. Browse,
              book and stay somewhere with a story.
            </p>
          </div>

          <nav aria-label="Explore" className="text-sm">
            <h2 className="font-semibold uppercase tracking-wider text-cream/50">Explore</h2>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/search" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  All hotels
                </Link>
              </li>
              <li>
                <Link to="/list-your-property" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  List your hotel
                </Link>
              </li>
              <li>
                <Link to="/login" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  Sign in
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Company" className="text-sm">
            <h2 className="font-semibold uppercase tracking-wider text-cream/50">Company</h2>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/our-story" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  Our story
                </Link>
              </li>
              <li>
                <Link to="/press" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  Press
                </Link>
              </li>
              <li>
                <Link to="/contact" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/terms" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="transition hover:text-clay focus-visible:outline-none focus-visible:text-clay">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-sm text-cream/50 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} BestAcco. All rights reserved.</p>
          <p className="font-serif italic text-cream/60">Stay somewhere with a story.</p>
        </div>
      </div>
    </footer>
  );
}
